import queryString from "query-string";
import { useQuery } from "react-query";
import {
    GetPenyewaSaatIniResponse,
} from "../../constants/types";
import axios from "../axios";

const handleRequest = async (
    id: number,
) => {
    const apiUrl = queryString.stringifyUrl({
        url: `/api/mruangans-khusus/${id}/extends`,
    });
    const { data } = await axios.get<GetPenyewaSaatIniResponse>(apiUrl);
    return data.data;
};

export default function useDetailHistoryRoomSpecialExtends(id: number, enabled: boolean) {
    return useQuery<GetPenyewaSaatIniResponse["data"]>(
        ["detailRoomSpecialExtends", id],
        () => handleRequest(id),
        { enabled: !!id && enabled }
    );
}


